import { render, staticRenderFns } from "./SpammerPage.vue?vue&type=template&id=2e55182a&scoped=true&"
import script from "./SpammerPage.vue?vue&type=script&lang=js&"
export * from "./SpammerPage.vue?vue&type=script&lang=js&"
import style0 from "./SpammerPage.vue?vue&type=style&index=0&id=2e55182a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e55182a",
  null
  
)

export default component.exports